import React from 'react';
import bg from '../../../Assets/Images/Wallpaper1.jpg';
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";


export default function ToeSeparator() {

function Corns() {
    return (
        <div class="row Pages-font-size">
        <div class="col-sm-4 justify-content-center">
        <img class="w-100 rounded mt-2" src={bg} alt=""/>
        </div>
        <div class="col-sm-8  mt-2 mb-5">
        <h3>CORNS / CALLUSES</h3>
        <p></p>
            <p>
            Corns and calluses are hard, thickened areas of skin that form as a consequence of rubbing,
             friction or pressure on the skin.Corns generally occur on the tops and sides of the toes. 
             A hard corn is a small patch of thickened, dead skin with a small plug of skin in the center.
            </p>
            <p>
            A hard corn is a small patch of thickened, dead skin with a small plug of skin in the center. 
            A soft corn has a much thinner surface, appears whitish and rubbery, and
             usually occurs between the toes. Seed corns are clusters of tiny corns that 
             can be very tender if they are on a weight-bearing part of the foot. 
             Seed corns tend to occur on the bottom of the feet, 
            and some doctors believe this condition is caused by blocked sweat ducts.
             </p>
             <p>
             Calluses are hard and rough-feeling areas of skin that can develop on hands, 
             feet or anywhere there is repeated friction - even on a violinist&#39;s chin. 
             Like corns, calluses have several variants. The common callus usually occurs when 
             there has been a lot of rubbing against the hands or feet. 
             A plantar callus is found on the bottom of the foot.</p>

<p>
Other risk factors for developing a corn or callus include foot 
deformities and wearing shoes or sandals without socks, which leads to friction on the feet. 
Rubbing or pressure can cause either soft corns or plantar calluses. The best way to prevent 
corns and calluses is to buy shoes that fit well. Avoid tight-fitting or narrow-toed shoes. 
Avoid heels or shoes that force pressure on your toes.

             </p><br/>
             <h4>CORRECTIONS</h4>
             <p></p>

             <ol>
                <li>Most corns and calluses gradually disappear when the friction or pressure stops. 
                   Custom made insoles(offloading) help to reduce 
                   the pressure on the problem areas and eases pain and helps in faster healing.</li><br/>
                <li>Consult a doctor if the problem persists</li>
            </ol>

        </div>
        </div>
    );
  }

function PlantarFacsiitis() {
    return (
        <div class="row">
        <div class="col-sm-4 justify-content-center">
        <img class="w-100 rounded mt-2" src={bg} alt=""/>
        </div>
        <div class="col-sm-8  mt-2 mb-5">
           <h2>PLANTAR FASCIITIS</h2>
           <p></p>
            <p>
            The plantar fascia is a flat band of tissue (ligament) that connects your heel bone to your 
            toes. The plantar fascia is the largest ligament in the human body. It supports the arch of 
            your foot. If you strain your plantar fascia, it gets weak, swollen, 
            and irritated (inflamed). Then your heel or the bottom of your foot 
            hurts when you stand or walk.
            <br/><br/>
Plantar fasciitis is one of the most common causes of heel pain.
 It involves inflammation of a thick band of tissue that runs across
  the bottom of your foot and connects your heel bone to your toes. 
  Plantar fasciitis is most commonly caused by strain injury causing micro 
  tears to the ligament as it attaches to the heel bone or other areas of 
  tightness on the sole of the foot.
<br/><br/>
Plantar fasciitis commonly causes stabbing pain that usually occurs with your first steps in the morning.
 As you get up and move more, the pain normally decreases, but it might return after 
 long periods of standing or after rising from sitting.
<br/><br/>
There are more than 10 million cases per year in India and is easily identifiable . 
The symptoms include stabbing pain near the heel. Pain might be worse in the morning
 and with prolonged standing, running or jumping. Treatments include physiotherapy, 
 stretching exercises, shoe inserts, pain relievers, steroid injections and surgery. 
<br/><br/>
            </p>

        </div>
        </div>
    );
  }
  function HeelPain() {
    return (
        <div class="row">
        <div class="col-sm-4 justify-content-center">
        <img class="w-100 rounded mt-2" src={bg} alt=""/>
        </div>
        <div class="col-sm-8  mt-2 mb-5">
           <h2>HEEL PAIN</h2>
           <p></p>
            <p>
            Heel pain is a very common foot problem. The sufferer usually feels pain 
            either under the heel (plantar fasciitis) or just behind it (Achilles tendinitis),
             where the Achilles tendon connects to the heel bone. 
            <br/><br/>
Even though heel pain can be severe and sometimes disabling, it is rarely a health threat.
 Heel pain is typically mild and usually disappears on its own; however, in some cases the
  pain may persist and become chronic (long-term). 
<br/><br/>
In majority of cases, heel pain has a mechanical cause. It may also be caused by arthritis,
 infection, an autoimmune problem trauma, a neurological problem, or some other systemic 
 condition (condition that affects the whole body). There may be various causes of heel
  pain like Plantar fasciitis (plantar fasciosis) -  inflammation of the plantar fascia, 
  Heel bursitis - inflammation of the back of the heel, the bursa (a fibrous sac full of fluid) 
  ,Heel bumps (pump bumps) ,Tarsal tunnel syndrome ,Chronic inflammation of the heel pad , 
  Stress fracture,Severs disease (calcaneal apophysitis) ,
  Achilles tendonosis (degenerative tendinopathy). 
<br/><br/>
            </p>
            <h4>Symptoms of heel pain :</h4><br/>
            <p>Heel pain typically comes on gradually, with no injury to the affected area. It is frequently triggered by wearing a flat shoe, such as flip-flop sandals. Flat footwear may stretch the plantar fascia to such an extent that the area becomes swollen or inflamed.In most cases, the pain is under the foot, toward the front of the heel.New research from the US suggests that wearing shoes such as high heels, 
               pumps and sandals was strongly linked in women's later life with heel and ankle pain. </p><br/>
            <h4>Treatments for heel pain :</h4><br/>
            <p>The following are common treatments for heel pain: </p>
            <ol>
                <li>Non-steroidal anti-inflammatory drugs (After consultation with a doctor) </li>
                <li>Corticosteroids </li>
                <li>Home care such as rest, ice-pack use, proper-fitting footwear 
                   and foot supports are often enough to ease heel pain. </li>
                <li>Physical therapy (physiotherapy) </li>
                <li>Night splints </li>
            </ol>
            <p>In cases that are not severe, home care is probably enough to get rid of heel pain.</p>
            <ol>
            <li>Rest - avoid running or standing for long periods, or 
               walking on hard surfaces. Avoid activities that may stress the heels.</li>
            <li>Ice - place an ice-pack on the affected 
               area for about 15 minutes. Do not place bare ice directly onto skin.</li>
            <li>Footwear - proper-fitting shoes that provide good support are crucial. 
               Athletes should be particularly fussy about the shoes they use when practicing or competing - sports shoes need to be replaced at specific intervals (ask your trainer).
</li>
            <li>Foot supports - wedges and heel cups and Insoles can help relieve symptoms.</li>
            </ol>
        </div>
        </div>
    );
  }
  function FlatFeet() {
    return (
        <div class="row">
        <div class="col-sm-4 justify-content-center">
        <img class="w-100 rounded mt-2" src={bg} alt=""/>
        </div>
        <div class="col-sm-8  mt-2 mb-5">
            <p>
            Most people have a gap under the arch of their foot when they are standing. The arch, the inner part of the foot is slightly raised off the ground. People with flat feet or fallen arches either have no arch, or it is very low. 
            <br/><br/>
The feet of people with fallen arches may roll over to the inner side when they are standing or walking, known as over pronation. The feet may point outward.  Some simple devices and exercises can help reduce the discomfort of flat feet. 
<br/><br/>

If there is no space under the arch, the person has flat feet. In a person with fallen arches, one or both feet may be flat on the ground, and shoes may wear unevenly, especially on one side, or they may wear out more quickly than usual.
<br/><br/>
Many people with fallen arches have no symptoms, but some may experience pain in their feet and even their back, depending on the cause. Symptoms can vary and generally depend on the severity of the condition. Some people have an uneven distribution of body weight and find that the heel of their shoes wears out more rapidly and more on one side than the other. The most common symptom of flat feet is pain. Pain may occur in the feet, if the connecting ligaments and muscles are strained.
<br/><br/>
The abnormal stresses on the knee and hip may result in pain. This is likely if the ankles turn inwards. Flat feet can also lead to pain in the lower back. There may also be stiffness in one or both feet.
<br/><br/>
            </p>
            <h4>Causes of flat feet include:</h4><br/>
            <ol>
                <li>Genetic factors, as flat feet can run in families</li>
                <li>Weak arches, where the foot arch is visible for example, 
                  when sitting, but the foot flattens onto the ground when standing</li>
                <li>Foot or ankle injury</li>
                <li>Arthritis or rheumatoid arthritis</li>
                <li>Damage, dysfunction, or rupture of the posterior tibial tendon</li>
                <li>Nervous system or muscle diseases, such as cerebral palsy, muscular dystrophy, or spina bifida</li>
                <li>Tarsal coalition, where the bones of the foot fuse together in an
                    unusual way, resulting in stiff and flat feet. 
                   This is most commonly diagnosed during childhood</li>
            </ol>
            <p>People are more likely to develop flat feet if they have obesity or diabetes, or during pregnancy.
Flat feet can also develop as people age. This can cause the posterior tibial tendon to weaken. This tendon is the main support structure of the arch of the feet.The tendon can become inflamed after overuse, known as tendinitis, or be torn. Damage to the tendon may cause the arch shape of the foot to flatten.
Flat feet can happen because of a developmental fault that occurs during childhood, or that develops with age, or after pregnancy.
Some people appear to have a very low arch or no arch without ever experiencing problems. Fallen arches or flat feet only need attention if they lead to discomfort, if they indicate another underlying disorder, or if they can lead to future pain elsewhere in the body.
Usage of Customised Insoles from FootPro can help to correct the deformity by offering adequate arch support and brings in pain relief by offering the necessary arch support. These insoles have to be used continuously as there is little possibility of formation of arches after adulthood.
</p><br/>
<h4>Flat feet in children </h4><br/>
<p>Children and infants often look as if they have flat feet. The arch is usually there, 
   but the feet are still forming. In time, the arch will appear as normal. 
   The extra fat on an infant’s foot may also be hiding the arch. Having apparently 
   flat feet during early childhood does not mean that the person will always have flat feet.
    Children with flat feet can be assisted with an arch support (Right Insoles), before the
   bones and tendons become rigid and this will assist the body to form an arch.
   </p>
        </div>
        </div>
    );
  }
 

  return (
      <div className="container Pages-font-size">
      <h1 class="mt-5 text-center">BUNION &OVERLAPPING TOES</h1><br/><br/>
        <h2>TOE SEPARATOR / TOE STOPPER</h2><br/>
      <p>
      A hallux valgus deformity, commonly called a bunion, is when there is medial deviation of t
      he first metatarsal and lateral deviation of the great toe (hallux). The condition can lead 
      to painful motion of the joint. 
      <br/><br/>
Hallux valgus is the commonest forefoot deformity, with an estimated prevalence of around 30%.
 It causes symptoms on the medial edge of the foot, the sole, and the small toes. Non-operative 
 treatment may alleviate symptoms but does not correct the deformity of the big toe. 
</p><br/>

      <h1>CORNS / CALLUSES</h1>
        <Corns/>

      <h1>PLANTAR FASCIITIS</h1>
        <PlantarFacsiitis/>

      <h1>HEEL PAIN</h1>
        <HeelPain/>

      <h1>FLAT FEET</h1>
        <FlatFeet/>   

      </div>
  );
}